module.exports = __webpack_public_path__ + "static/media/FUN88_Affiliate_Page_Batchat_Icon.ef60f557.jpg";